export default function (change) {
  switch (change) {
    case "Success":
      return "Inicio correcto";
    case "Failure":
      return "Fallo";
    case "Unknown":
      return "Desconocido";
    default:
      return change;
  }
}